import React from "react";
import {FormattedMessage} from "react-intl";
import ServiceAreaChooser from "../../../components/ServiceAreaChooser";
import Logo from "../../../components/ui/Logo";

export default (props) => {

  return (
    <React.Fragment>

      <div className='row'>
        <div className='col-md-6'>
          <div className='alert alert-info'>
            <FormattedMessage id="home.intro" defaultMessage="This website will photograph your documents one page at a time and link them to you and your address."/>
          </div>
        </div>
      </div>

      <ServiceAreaChooser/>
      <Logo/>

    </React.Fragment>
  );
};
